export enum IOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  MIXED = 'mixed',
}
export enum IOrientationLabel {
  vertical = 'Vertical',
  horizontal = 'Horizontal',
  mixed = 'Mixed',
}

export enum IStatus {
  READY_TO_USE = 'ready',
  DRAFT = 'draft',
}
export enum IStatusLabel {
  ready = 'Ready to use',
  draft = 'Draft',
}

export enum INoScreens {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEN = '7',
}
